/**
 * Connect Auth Constants
 */

// Routes that are always accessible regardless of navbar_config
// From the doc: unauthenticatedRoutes in handleProviderRoutes
export const UNAUTHENTICATED_ROUTES = [
	"profile",
	"teams",
	"dashboard",
	"inventories",
	"bookings",
	"reviews",
	"invoices",
	"reports",
	"promotions",
];

// Login redirect URL
// On staging/production: /list works because nginx routes it to the old app
// On local dev: use VITE_CONNECT_LOGIN_URL env variable (full URL to old app)
export const LOGIN_REDIRECT_URL = "/list";

// Profile fallback URL (when route not allowed)
export const PROFILE_FALLBACK_URL = "/connect/profile";
